import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// 프론트엔드 시작 로그 기록 (한 번만 실행)
let startupLogged = false;
const logFrontendStartup = async () => {
  if (startupLogged) return;
  startupLogged = true;
  
  try {
    const apiBaseUrl =
      (window as any).__RUNTIME_CONFIG__?.VITE_API_URL ||
      import.meta.env.VITE_API_URL ||
      '/api';
    await fetch(`${apiBaseUrl}/admin/logs/system/frontend-startup`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
    });
  } catch (error) {
    // 로그 기록 실패해도 프론트엔드 시작은 계속됨
    console.debug('Failed to log frontend startup:', error);
  }
};

// 프론트엔드 시작 로그 기록
logFrontendStartup();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
